const returns = [
  {
    id: "#10421",
    checkbox: false,
    date: "1, 2, 3, 4",
    status: "Approved",
    statusIcon: "fas fa-check",
    customer: "Lumberjack Co",
    customerImg: require("@/assets/img/team-2.jpg"),
    product: "JAN 2023",
    revenue: "$40,20",
  },
  {
    id: "#10422",
    checkbox: false,
    date: "5, 6, 7, 8",
    status: "Approved",
    statusIcon: "fas fa-check",
    customer: "Big Cranes Scaffolds",
    customerImg: require("@/assets/img/team-1.jpg"),
    product: "FEB 2023",
    revenue: "$42,00",
  },
  {
    id: "#10423",
    checkbox: false,
    date: "9, 10, 11, 12",
    status: "Pending",
    statusIcon: "fas fa-exclamation",
    customer: "Michael Mirra",
    product: "MAR 2023",
    revenue: "$25,50",
  },
  {
    id: "#10424",
    checkbox: false,
    date: "13, 14, 15, 16",
    status: "Approved",
    statusIcon: "fas fa-check",
    customer: "Andrew Nichel",
    customerImg: require("@/assets/img/team-3.jpg"),
    product: "APR 2023",
    revenue: "$19,40",
  },
  {
    id: "#10425",
    checkbox: false,
    date: "17, 18, 19, 20",
    status: "Rejected",
    statusIcon: "fas fa-exclamation",
    customer: "Sebastian Koga",
    customerImg: require("@/assets/img/team-4.jpg"),
    product: "MAY 2023",
    revenue: "$44,90",
  },
  {
    id: "#10432",
    checkbox: false,
    date: "21, 22, 23, 24",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Brooks Roadworks",
    product: "JUN 2023",
    revenue: "$23,90",
  },
];

export default returns;
